<template>
  <!-- 安全密码二次确认(复用:发红包/删报表/更新房间号 等敏感操作) -->
  <Modal :value="value" :title="title" class="vertical-center-modal" :width="360"
    @on-visible-change="onVisible" @on-ok="confirm">
    <Form @submit.native.prevent>
      <FormItem label="安全密码" :label-width="70">
        <Input v-model="pwd" type="password" password placeholder="请输入安全密码" @on-enter="confirm" />
      </FormItem>
      <slot name="tip" />
    </Form>
    <template #footer>
      <dialog-footer :loading="loading" @cancel="close" @confirm="confirm" />
    </template>
  </Modal>
</template>

<script>
export default {
  name: 'SafePasswordDialog',
  props: {
    value: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    title: { type: String, default: '安全密码' }
  },
  data() {
    return { pwd: '' }
  },
  methods: {
    onVisible(v) { if (!v) this.close() },
    close() { this.pwd = ''; this.$emit('input', false) },
    confirm() {
      if (!this.pwd) { this.$Message.warning('请输入安全密码'); return }
      this.$emit('confirm', this.pwd)
    }
  }
}
</script>
